import React, { useState } from 'react';
import './popup.css';
import ReCAPTCHA from "react-google-recaptcha";
import { useNavigate } from 'react-router-dom';


const Popup = ({ show, onClose }) => {
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', message: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();


  const handleCaptchaChange = (value) => {
    setCaptchaVerified(!!value);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError('');
    setSuccess('');
  };

  if (!show) return null;

  const validateForm = () => {
    const { name, email, phone, message } = formData;
    if (!name || !email || !message) return "Please complete all required fields.";
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) return "Invalid email format.";
    const phoneRegex = /^[0-9]{10}$/;
    if (!phoneRegex.test(phone)) return "Phone must be 10 digits.";
    return '';
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationError = validateForm();
    if (validationError) {
      setError(validationError);
      return;
    }

    if (!captchaVerified) {
      alert("Please verify that you are not a robot.");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch("https://nspp.in/php/send_email.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData)

      });

      const result = await response.json();
      if (result.status === "success") {
        // setSuccess("Message sent successfully!");
        navigate('/thankyou')
        setFormData({ name: '', email: '', phone: '', message: '' });
      } else {
        setError(result.message || "Something went wrong.");
      }
    } catch (err) {
      setError("Error connecting to server.");
    } finally {
      setLoading(false); // Stop loading
    }
  };
  // if (!show) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-container">
        <button className="close-btn" onClick={onClose}>×</button>
        <h2>Contact Form</h2>

        {error && <p style={{ color: 'red' }}>{error}</p>}
        {success && <p style={{ color: 'green' }}>{success}</p>}

        <form onSubmit={handleSubmit}>
          <input type="text" name="name" placeholder="Name" value={formData.name} onChange={handleChange} required />
          <input type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange} required />
          <input type="tel" name="phone" placeholder="Phone Number" value={formData.phone} onChange={handleChange} required />
          <textarea name="message" placeholder="Your Message" value={formData.message} onChange={handleChange} required />
          <ReCAPTCHA
            // sitekey="6LdyK74qAAAAAHior1ETtBZRJf6-78AZFgkPYKf3"
            sitekey='6LeXcGorAAAAACdSVPL7n-JsQGj52OOs8aMvKkvr'

            onChange={handleCaptchaChange}
          />
          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? "Sending..." : "Submit"}
          </button>
        </form>
      </div>
    </div>
  );
}
export default Popup;
